import { TFeature } from '@/shared/types/geojson';
import { LngLatBounds } from "maplibre-gl";
import bbox from "@turf/bbox"
import { BBox2d } from "@turf/helpers/dist/js/lib/geojson";

export function getBounds(features: TFeature[]) {
	const b = bbox(featureCollection(features)) as BBox2d;
	return LngLatBounds.convert(b)
}

function featureCollection(features: TFeature[]) {
	return {
		type: "FeatureCollection",
		features
	};
}